export default __webpack_public_path__ + "static/media/gc_icon.50630920.png";